import { render, staticRenderFns } from "./PageABCBookCover.vue?vue&type=template&id=5b6ac15f&scoped=true&"
import script from "./PageABCBookCover.vue?vue&type=script&lang=js&"
export * from "./PageABCBookCover.vue?vue&type=script&lang=js&"
import style0 from "./PageABCBookCover.vue?vue&type=style&index=0&id=5b6ac15f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6ac15f",
  null
  
)

export default component.exports